export interface IMenuItem {
  name: string
  path: string
  disabled: boolean
}

export const menuVehicle: IMenuItem[] = [
  {
    name: 'Přehled',
    path: '/',
    disabled: false
  },
  {
    name: 'Nabídky',
    path: '/concepts',
    disabled: false,
  },
  {
    name: 'Smlouvy',
    path: '/contracts',
    disabled: false,
  },
]

export const menuLeasing: IMenuItem[] = [
  {
    name: 'Přehled',
    path: '/leasing',
    disabled: false
  },
  {
    name: 'Nabídky',
    path: '/leasing/concepts',
    disabled: false,
  },
  {
    name: 'Smlouvy',
    path: '/leasing/contracts',
    disabled: false,
  },
]

export const menuFleet: IMenuItem[] = [
  {
    name: 'Přehled',
    path: '/fleet',
    disabled: false
  },
  {
    name: 'Nabídky',
    path: '/fleet/concepts',
    disabled: false,
  },
  {
    name: 'Smlouvy',
    path: '/fleet/contracts',
    disabled: false,
  },
]

export const menuTravel: IMenuItem[] = [
  {
    name: 'Přehled',
    path: '/travel',
    disabled: false
  },
  {
    name: 'Nabídky',
    path: '/travel/concepts',
    disabled: false,
  },
  {
    name: 'Smlouvy',
    path: '/travel/contracts',
    disabled: false,
  },
  {
    name: 'Informace',
    path: '/travel',
    disabled: true
  },
]

export const menuProperty: IMenuItem[] = [
  {
    name: 'Přehled',
    path: '/property',
    disabled: false
  },
  {
    name: 'Nabídky',
    path: '/property/concepts',
    disabled: false,
  },
  {
    name: 'Smlouvy',
    path: '/property/contracts',
    disabled: false,
  }
]
